const PaymentIcon = () => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_305_8696)">
        <path
          d="M4.67597 5.61153C4.70411 5.35832 4.91814 5.16675 5.17292 5.16675H15.1606C15.4586 5.16675 15.6905 5.42578 15.6575 5.72196L15.2131 9.72196C15.185 9.97518 14.9709 10.1667 14.7162 10.1667H4.72847C4.43047 10.1667 4.19862 9.90772 4.23153 9.61153L4.67597 5.61153Z"
          stroke="white"
        />
        <rect
          x="0.5"
          y="5.29761"
          width="3.33333"
          height="0.666667"
          rx="0.333333"
          fill="white"
        />
        <rect
          x="0.5"
          y="7.29761"
          width="2.66667"
          height="0.666667"
          rx="0.333333"
          fill="white"
        />
        <rect
          x="0.5"
          y="9.33325"
          width="2"
          height="0.666667"
          rx="0.333333"
          fill="white"
        />
        <circle cx="9.94446" cy="7.66675" r="0.5" stroke="white" />
        <circle cx="12.8333" cy="7.66659" r="0.333333" fill="white" />
        <circle cx="6.83333" cy="7.66659" r="0.333333" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_305_8696">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PaymentIcon;
